import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The Autonomous Child Visual System™ (50-page eBook, 6 volumes)',
  price: '$19'
}, {
  label: '🎨 Bonus #1: The Neuro-Friendly Icon Vault',
  price: 'FREE'
}, {
  label: '🗓️ Bonus #2: Weekend & Holiday Transition Guide',
  price: 'FREE'
}, {
  label: '💬 Bonus #3: Power Struggle Script Book',
  price: 'FREE'
}, {
  label: '✈️ Bonus #4: Print-and-Go Travel Routine Cards',
  price: 'FREE'
}, {
  label: '😴 Bonus #5: The Sleep-Anchor Checklist',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & future updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-224" data-mp="1tg4qg3i791jt">
      
    </section>;
}